<template>
  <div class="animated fadeIn">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    <!-- <div>
      <b-row>
        <b-col cols="12">
          <b-card hide-hader>
            <b-button class="float-right" variant="success" @click="redirecionar">Adquirir Pacotes</b-button>
            <span class="f-g">
              <h3 v-if="quantia_push == 0">Você não possui pushs disponíveis</h3>
              <h3 v-if="quantia_push > 0">
                Você possui
                <strong>{{quantia_push}}</strong> pushs disponíveis
              </h3>
            </span>
          </b-card>
        </b-col>
      </b-row>
    </div>-->
    <div>
      <b-row>
        <b-col cols="12">
          <b-card header="Pacotes ativos">
            <b-table
              hover
              :items="items_ativos"
              :fields="fields_ativos"
              :busy="isBusy_ativos"
              bordered
              striped
              show-empty
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
                <strong>&nbsp;&nbsp;Carregando...</strong>
              </div>
              <template slot="empty">
                <h5>Não encontramos nenhum pacote associado à sua empresa</h5>
              </template>
              <template slot="tipoid" slot-scope="data">
                <span v-if="data.item.tipoid == 1">Push</span>
                <span v-else @click="log(data)">Misc</span>
              </template>
              <template slot="ismensal" slot-scope="data">
                <span v-if="data.item.ismensal == 1">Sim</span>
                <span v-else @click="log(data)">Não</span>
              </template>
            </b-table>
          </b-card>
        </b-col>
        <b-col cols="12" v-if="items.length > 0">
          <b-card header="Adquirir pacotes">
            <b-table
              hover
              :items="items"
              :fields="fields"
              :busy="isBusy"
              bordered
              striped
              show-empty
            >
              <template slot="tipoid" slot-scope="data">
                <span>{{ data.item.tipoid == 1 ? 'Push' : data.item.tipoid == 2 ? 'Email' : 'SMS' }}</span>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
                <strong>&nbsp;&nbsp;Carregando...</strong>
              </div>
              <template slot="empty">
                <h5>Não encontramos nenhum pacote no momento</h5>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "pacotes",
  components: {
    Loading
  },
  data: function() {
    return {
      quantia_push: null,
      isBusy_ativos: false,
      isBusy: false,
      isLoading: false,
      items_ativos: [],
      fields_ativos: [
        { key: "tipoid", label: "Tipo" },
        { key: "quantidadeadquirida", label: "Qtd. adquirida" },
        { key: "quantidadeutilizada", label: "Qtd. utilizada" },
        { key: "ismensal", label: "Mensal" },
        { key: "dataaquisicao", label: "Data de Aquisição" },
        { key: "datavalidade", label: "Data de Vencimento" }
      ],
      items: [],
      fields: [
        { key: "tipoid", label: "Tipo" },
        "quantidade",
        "valor",
        "validade"
      ]
    };
  },
  methods: {
    log(data) {
      console.log(data);
    },
    redirecionar() {
      this.$router.push("/pacotes/adquirir-pacotes");
    },
    makeToast(variant = null, content, title) {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true
      });
    }
  },

  async beforeMount() {
    console.info(this.$route.query);
    if (this.$route.query.status) {
      if (this.$route.query.status == "APRO")
        this.makeToast(
          "success",
          "Parabéns, seu pacote foi adquirido com sucesso!",
          "Pagamento Aprovado"
        );
      else
        this.makeToast(
          "danger",
          "Verifique seus dados e tente novamente mais tarde.",
          "Pagamento Recusado"
        );
    }
    this.isLoading = true;
    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-pushs-disponiveis/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.status == 200) {
          if (response.data) this.quantia_push = response.data.pushsDisponiveis;
        }
      });

    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-pacotes-ativos/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.status == 200) {
          if (response.data.data)
            if (response.data.data.length > 0)
              this.items_ativos = response.data.data;
        }
      });
    this.isLoading = false;
  }
};
</script>


